<!--分组商品链接（原引流、礼包商品列表）-->
<template>
  <div class="newPer" v-wechat-title="headtitle">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"

    >
      <img :src="bannerImg" width="100%">
<!--      <div style="background-color: #fff;padding: 0.2rem 0.15rem;">-->
<!--        <ul>-->
<!--          <li v-for="(item, index) of list" :key="index" @click="newPerClick(item)">-->
<!--            <img v-lazy="item.img_path">-->
<!--            <div class="proMess">-->
<!--              <div class="tags">-->
<!--                <p v-if="item.tag1">{{item.tag1}}</p>-->
<!--                <p v-if="item.tag2">{{item.tag2}}</p>-->
<!--                <p v-if="item.tag3">{{item.tag3}}</p>-->
<!--                &lt;!&ndash;<p>产品卖点</p>&ndash;&gt;-->
<!--              </div>-->
<!--              <b>{{item.name}}</b>-->
<!--              <div class="span">-->
<!--                <div class="goods_price">-->
<!--                  <span class="smallprice">-->
<!--                    <sub>¥</sub>-->
<!--                    <b>{{String(parseFloat(item.sales_price).toFixed(2)).slice(0, String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'))}}</b>-->
<!--                    <sup>{{String(parseFloat(item.sales_price).toFixed(2)).slice(String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'), String(parseFloat(item.sales_price).toFixed(2)).length)}}</sup>-->
<!--                  </span>-->
<!--                </div>-->
<!--                <i>¥{{item.cost_price}}</i>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="clear"></div>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
      <div class="pro_list">
        <product-item v-for="(item, index) of list" :key="index" :prolistItem="item" :type="'notScrollTo'" :skuSwitch="'1'"
                      :markPointData="{scenepoint:'GIFTBAG'}"></product-item>
      </div>
    </Scroller>
    <div class="floatBtn_new">
      <img v-if="isnewpersontask" @click="newpersontask" src="/static/images/new-person/newpersontask@2x.png">
    </div>
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import { kefu, fenxiang, basepath, isApp, isWeixin, Base64 } from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
import productItem from '../common/productItem'
import wx from 'weixin-js-sdk'

export default {
  name: 'giftBagProduct',
  data () {
    return {
      headtitle: '',
      list: [],
      bannerImg: '',
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      isnewpersontask: 0,
      newpersonjump: ''
    }
  },
  components: {
    Scroller,
    productItem
  },
  mounted: function () {
    window.scrollTo(0, 0)
    this.$newuserFn((data) => {
      if (data.code == 200) {
        this.isnewpersontask = data.isnewpersontask
        this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
      }
    })
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/' && from.name != 'homePage') { // 当前页面刷新不需要切换位置
      // sessionStorage.askPositon = ''
      next(vm => {
        // Object.assign(vm.$data, vm.$options.data());
      })
    } else {
      next(vm => {
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    this.loading = true
    next()
  },
  methods: {
    getData: function () {
      if (!this.$route.query.id) return
      var url = 'Wxmall/Adactinfo/getNewGroupActivityItem?id=' +this.$route.query.id+ '&pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      var that = this
      customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.share(res.data.shareInfo)
          if (that.nowPage === 1) {
            that.headtitle = that.$route.meta.title = res.data.title
            that.list = res.data.itemlist
            that.bannerImg = res.data.bannerimg
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.itemlist)
            that.bannerImg = res.data.bannerimg
          }
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    newpersontask () {
      var arg = isApp()
      window.location = this.newpersonjump + (this.newpersonjump.indexOf('?') >= 0 ? arg : ('?1=1' + arg))
    },
    share(shareInfo) {
      let base = new Base64()
      let params = {
        title: encodeURIComponent(shareInfo.title),
        desc: encodeURIComponent(shareInfo.desc),
        imgx: shareInfo.img,
        type: 'giftproudct',
        path: 'giftbagproduct',
        dataStr: 'type=giftproudct&params=' + base.encode(JSON.stringify({id: this.$route.query.id}))
      }, arg = isApp()
      if (arg.indexOf('xcx') >= 0) {
        var xcxObj = {
          type: 'giftproudct',
          link: basepath + 'giftbagproduct?id=' + this.$route.query.id + arg,
          title: encodeURIComponent(shareInfo.title),
          img: shareInfo.img
        }
        wx.miniProgram.postMessage({data: xcxObj})
      } else if (arg == '' && isWeixin()) {
        fenxiang(params)
      }
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    }
  }
}
</script>

<style scoped lang="scss">
.newPer {
  background: #fff;
  min-height: 100%;
  >img {
    width: 100%;
  }

  .pro_list{
    padding: 0.1rem .11rem 0;
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    .pro_item:nth-child(2n){
      padding-left: .035rem;
    }
    .pro_item:nth-child(2n-1){
      padding-right: .035rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/giftBagProduct.vue